import React from 'react';
import { SettingsDirectoryRow } from './SettingsDirectoryRow';
import type {
  DirectoryGroupConfig,
  DirectorySource,
} from './settingsDirectoryConfig';
import type { DirectoryRowState } from './useSettingsDirectory';

interface SettingsDirectoryGroupProps {
  group: DirectoryGroupConfig;
  rows: Record<DirectorySource, DirectoryRowState>;
}

export const SettingsDirectoryGroup: React.FC<SettingsDirectoryGroupProps> = ({
  group,
  rows,
}) => {
  const Icon = group.icon;
  const headingId = `settings-group-${group.id}`;
  return (
    <section aria-labelledby={headingId}>
      <div className="mb-2 flex items-center gap-2 px-1">
        <Icon size={15} className="text-gray-400" aria-hidden />
        <h2 id={headingId} className="text-sm font-semibold text-gray-700">
          {group.title}
        </h2>
      </div>
      <ul className="divide-y divide-gray-100 overflow-hidden rounded-xl border border-gray-200 bg-white">
        {group.rows.map((row) => (
          <SettingsDirectoryRow key={row.id} row={row} state={rows[row.id]} />
        ))}
      </ul>
    </section>
  );
};
